import React, { useEffect } from "react";
import Modal from "./components/Modal";
import modalState from "./state-observables/modal/ModalState";
import {
  ModalEventTopics,
  ModalStateData,
} from "./state-observables/modal/ModalObserver";
import LandingPage from "./LandingPage";

function App() {
  const [modalData, setModalData] = React.useState<null | ModalStateData>(null);
  const [shouldCloseModal, setShouldCloseModal] = React.useState(false);

  const modalSubscriptionHelper = React.useMemo(
    () => ({
      notify(eventTopic: ModalEventTopics, eventData: ModalStateData) {
        switch (eventTopic) {
          case "SetModal":
            setShouldCloseModal(false);
            setModalData(eventData);
            break;
          case "CloseModal":
            setShouldCloseModal(true);
            setModalData(null);
            break;
          case "UpdateModalProps":
            setModalData((prevModalData) => {
              if (prevModalData) {
                return {
                  ...prevModalData,
                  ...eventData,
                };
              }
              return prevModalData;
            });
            break;
        }
      },
    }),
    []
  );

  // Create subscription to the modal states
  useEffect(() => {
    // Subscribe
    modalState.subscribe(modalSubscriptionHelper, [
      "SetModal",
      "CloseModal",
      "UpdateModalProps",
    ]);
    // Return unsubscribe function
    return () => {
      modalState.unsubscribe(modalSubscriptionHelper);
    };
  }, [modalSubscriptionHelper]);

  const resetModal = () => {
    setShouldCloseModal(false);
    setModalData(null);
  };

  const ModalContent = modalData?.modalContent;

  return (
    <>
      {!!ModalContent && (
        <Modal
          show={!!ModalContent}
          closing={shouldCloseModal}
          title={modalData ? modalData.modalTitle || "" : ""}
          onClose={resetModal}
        >
          {ModalContent}
        </Modal>
      )}
      <LandingPage />
    </>
  );
}

export default App;
